import { handleInputChange } from "legacy/helpers.es6"
import React from "react"

class ApplicationComponent extends React.Component {
  constructor(props) {
    super(props)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }
}

export default ApplicationComponent
